import mod from "./index.js";

export default mod;
export const AlignCenter = mod.AlignCenter;
export const AlignJustify = mod.AlignJustify;
export const AlignLeft = mod.AlignLeft;
export const AlignRight = mod.AlignRight;
export const Animation = mod.Animation;
export const AnimationSolid = mod.AnimationSolid;
export const AnnotationQuestion = mod.AnnotationQuestion;
export const AnnotationQuestionSolid = mod.AnnotationQuestionSolid;
export const ArrowDown = mod.ArrowDown;
export const ArrowDownCricle = mod.ArrowDownCricle;
export const ArrowDownCricleSolid = mod.ArrowDownCricleSolid;
export const ArrowDownLeft = mod.ArrowDownLeft;
export const ArrowDownRight = mod.ArrowDownRight;
export const ArrowDownSolid = mod.ArrowDownSolid;
export const ArrowDownTray = mod.ArrowDownTray;
export const ArrowDownTraySolid = mod.ArrowDownTraySolid;
export const ArrowLeft = mod.ArrowLeft;
export const ArrowLeftCircle = mod.ArrowLeftCircle;
export const ArrowLeftCircleSolid = mod.ArrowLeftCircleSolid;
export const ArrowLeftTray = mod.ArrowLeftTray;
export const ArrowLeftTraySolid = mod.ArrowLeftTraySolid;
export const ArrowNarrowDown = mod.ArrowNarrowDown;
export const ArrowNarrowLeft = mod.ArrowNarrowLeft;
export const ArrowNarrowRight = mod.ArrowNarrowRight;
export const ArrowNarrowTop = mod.ArrowNarrowTop;
export const ArrowNarrowTopSolid = mod.ArrowNarrowTopSolid;
export const ArrowRight = mod.ArrowRight;
export const ArrowRightCircle = mod.ArrowRightCircle;
export const ArrowRightCircleSolid = mod.ArrowRightCircleSolid;
export const ArrowRightTray = mod.ArrowRightTray;
export const ArrowRightTraySolid = mod.ArrowRightTraySolid;
export const ArrowTopRightOnSquare = mod.ArrowTopRightOnSquare;
export const ArrowTopRightOnSquareSolid = mod.ArrowTopRightOnSquareSolid;
export const ArrowTopTray = mod.ArrowTopTray;
export const ArrowTopTraySolid = mod.ArrowTopTraySolid;
export const ArrowTrendDown = mod.ArrowTrendDown;
export const ArrowTrendUp = mod.ArrowTrendUp;
export const ArrowUp = mod.ArrowUp;
export const ArrowUpCircle = mod.ArrowUpCircle;
export const ArrowUpCircleSolid = mod.ArrowUpCircleSolid;
export const ArrowUpLeft = mod.ArrowUpLeft;
export const ArrowUpRight = mod.ArrowUpRight;
export const ArrowsPointingIn = mod.ArrowsPointingIn;
export const ArrowsPointingOut = mod.ArrowsPointingOut;
export const ArrowsRightLeft = mod.ArrowsRightLeft;
export const ArrowsUpDown = mod.ArrowsUpDown;
export const Award = mod.Award;
export const AwardSolid = mod.AwardSolid;
export const BarsProgress = mod.BarsProgress;
export const BarsProgressSolid = mod.BarsProgressSolid;
export const Bell = mod.Bell;
export const BellSolid = mod.BellSolid;
export const BitcoinCircle = mod.BitcoinCircle;
export const BitcoinCircleSolid = mod.BitcoinCircleSolid;
export const Bold = mod.Bold;
export const Bolt = mod.Bolt;
export const BoltSolid = mod.BoltSolid;
export const Book = mod.Book;
export const BookOpen = mod.BookOpen;
export const BookOpenSolid = mod.BookOpenSolid;
export const BookSolid = mod.BookSolid;
export const Bookmark = mod.Bookmark;
export const BookmarkSolid = mod.BookmarkSolid;
export const Boolean = mod.Boolean;
export const BoxArchive = mod.BoxArchive;
export const BoxArchiveSolid = mod.BoxArchiveSolid;
export const Briefcase = mod.Briefcase;
export const BriefcaseSolid = mod.BriefcaseSolid;
export const Browser = mod.Browser;
export const BrowserSolid = mod.BrowserSolid;
export const Calculator = mod.Calculator;
export const CalculatorSolid = mod.CalculatorSolid;
export const Calendar = mod.Calendar;
export const CalendarSolid = mod.CalendarSolid;
export const Case = mod.Case;
export const Category = mod.Category;
export const CategorySolid = mod.CategorySolid;
export const ChartArea = mod.ChartArea;
export const ChartAreaSolid = mod.ChartAreaSolid;
export const ChartBar = mod.ChartBar;
export const ChartBullet = mod.ChartBullet;
export const ChartBulletSolid = mod.ChartBulletSolid;
export const ChartColumn = mod.ChartColumn;
export const ChartLine = mod.ChartLine;
export const ChartNetwork = mod.ChartNetwork;
export const ChartNetworkSolid = mod.ChartNetworkSolid;
export const ChartPie = mod.ChartPie;
export const ChartPieSolid = mod.ChartPieSolid;
export const ChartPyramid = mod.ChartPyramid;
export const ChartPyramidSolid = mod.ChartPyramidSolid;
export const ChartRadar = mod.ChartRadar;
export const ChartRadarSolid = mod.ChartRadarSolid;
export const ChartScatter = mod.ChartScatter;
export const ChartSimple = mod.ChartSimple;
export const ChartSimpleHorizontal = mod.ChartSimpleHorizontal;
export const ChartSimpleHorizontalSolid = mod.ChartSimpleHorizontalSolid;
export const ChartSimpleSolid = mod.ChartSimpleSolid;
export const ChartWaterfall = mod.ChartWaterfall;
export const Check = mod.Check;
export const CheckCircle = mod.CheckCircle;
export const CheckCircleSolid = mod.CheckCircleSolid;
export const CheckSquare = mod.CheckSquare;
export const CheckSquareSolid = mod.CheckSquareSolid;
export const ChevronDown = mod.ChevronDown;
export const ChevronLeft = mod.ChevronLeft;
export const ChevronRight = mod.ChevronRight;
export const ChevronUp = mod.ChevronUp;
export const Circle = mod.Circle;
export const CircleSolid = mod.CircleSolid;
export const Clipboard = mod.Clipboard;
export const ClipboardArrowUp = mod.ClipboardArrowUp;
export const ClipboardArrowUpSolid = mod.ClipboardArrowUpSolid;
export const ClipboardAttachment = mod.ClipboardAttachment;
export const ClipboardAttachmentSolid = mod.ClipboardAttachmentSolid;
export const ClipboardList = mod.ClipboardList;
export const ClipboardListSolid = mod.ClipboardListSolid;
export const ClipboardMinus = mod.ClipboardMinus;
export const ClipboardMinusSolid = mod.ClipboardMinusSolid;
export const ClipboardPlus = mod.ClipboardPlus;
export const ClipboardPlusSolid = mod.ClipboardPlusSolid;
export const ClipboardSolid = mod.ClipboardSolid;
export const ClipboardText = mod.ClipboardText;
export const ClipboardTextSolid = mod.ClipboardTextSolid;
export const ClipboardUser = mod.ClipboardUser;
export const ClipboardUserSolid = mod.ClipboardUserSolid;
export const ClipboardX = mod.ClipboardX;
export const ClipboardXSolid = mod.ClipboardXSolid;
export const Clone = mod.Clone;
export const CloneSolid = mod.CloneSolid;
export const Cloud = mod.Cloud;
export const CloudArrowDown = mod.CloudArrowDown;
export const CloudArrowDownSolid = mod.CloudArrowDownSolid;
export const CloudArrowUp = mod.CloudArrowUp;
export const CloudArrowUpSolid = mod.CloudArrowUpSolid;
export const CloudSolid = mod.CloudSolid;
export const Code = mod.Code;
export const Collapse = mod.Collapse;
export const ColorPicker = mod.ColorPicker;
export const ColorPickerSolid = mod.ColorPickerSolid;
export const Company = mod.Company;
export const CompanySolid = mod.CompanySolid;
export const Compress = mod.Compress;
export const Contracts = mod.Contracts;
export const CornerLeftDown = mod.CornerLeftDown;
export const CornerRightUp = mod.CornerRightUp;
export const CornerUpLeft = mod.CornerUpLeft;
export const CornerUpRight = mod.CornerUpRight;
export const CreditCard = mod.CreditCard;
export const CreditCardSolid = mod.CreditCardSolid;
export const Data = mod.Data;
export const DataSolid = mod.DataSolid;
export const DiagramCells = mod.DiagramCells;
export const DiagramCellsSolid = mod.DiagramCellsSolid;
export const DiagramNested = mod.DiagramNested;
export const DiagramNestedSolid = mod.DiagramNestedSolid;
export const DiagramNext = mod.DiagramNext;
export const DiagramNextSolid = mod.DiagramNextSolid;
export const DiagramPredecessor = mod.DiagramPredecessor;
export const DiagramPredecessorSolid = mod.DiagramPredecessorSolid;
export const DiagramPrevious = mod.DiagramPrevious;
export const DiagramPreviousSolid = mod.DiagramPreviousSolid;
export const DiagramSankey = mod.DiagramSankey;
export const DiagramSubtask = mod.DiagramSubtask;
export const DiagramSubtaskSolid = mod.DiagramSubtaskSolid;
export const DiagramSuccessor = mod.DiagramSuccessor;
export const DiagramSuccessorSolid = mod.DiagramSuccessorSolid;
export const Diamond = mod.Diamond;
export const DiamondSolid = mod.DiamondSolid;
export const DiamondX = mod.DiamondX;
export const DiamondXSolid = mod.DiamondXSolid;
export const DistributeSpacingHorizontal = mod.DistributeSpacingHorizontal;
export const DistributeSpacingHorizontalSolid = mod.DistributeSpacingHorizontalSolid;
export const DistributeSpacingVertical = mod.DistributeSpacingVertical;
export const DistributeSpacingVerticalSolid = mod.DistributeSpacingVerticalSolid;
export const DollarCircle = mod.DollarCircle;
export const DollarCircleSolid = mod.DollarCircleSolid;
export const Dot = mod.Dot;
export const DotsHorizontal = mod.DotsHorizontal;
export const DotsVertical = mod.DotsVertical;
export const Drag = mod.Drag;
export const DrawSquare = mod.DrawSquare;
export const DrawSquareSolid = mod.DrawSquareSolid;
export const Email = mod.Email;
export const EmailSolid = mod.EmailSolid;
export const ExclamationCircle = mod.ExclamationCircle;
export const ExclamationCircleSolid = mod.ExclamationCircleSolid;
export const ExclamationTriangle = mod.ExclamationTriangle;
export const ExclamationTriangleSolid = mod.ExclamationTriangleSolid;
export const Expand = mod.Expand;
export const Eye = mod.Eye;
export const EyeSlash = mod.EyeSlash;
export const EyeSlashSolid = mod.EyeSlashSolid;
export const EyeSolid = mod.EyeSolid;
export const File = mod.File;
export const FileArrowDown = mod.FileArrowDown;
export const FileArrowDownSolid = mod.FileArrowDownSolid;
export const FileArrowUp = mod.FileArrowUp;
export const FileArrowUpSolid = mod.FileArrowUpSolid;
export const FileBlock = mod.FileBlock;
export const FileBlockSolid = mod.FileBlockSolid;
export const FileBookmark = mod.FileBookmark;
export const FileBookmarkSolid = mod.FileBookmarkSolid;
export const FileChartColumn = mod.FileChartColumn;
export const FileChartColumnSolid = mod.FileChartColumnSolid;
export const FileCheck = mod.FileCheck;
export const FileCheckSolid = mod.FileCheckSolid;
export const FileCode = mod.FileCode;
export const FileCodeSolid = mod.FileCodeSolid;
export const FileDashedLines = mod.FileDashedLines;
export const FileDashedLinesSolid = mod.FileDashedLinesSolid;
export const FileDollar = mod.FileDollar;
export const FileDollarSolid = mod.FileDollarSolid;
export const FileExclamation = mod.FileExclamation;
export const FileExclamationSolid = mod.FileExclamationSolid;
export const FileGraph = mod.FileGraph;
export const FileGraphSolid = mod.FileGraphSolid;
export const FileHeart = mod.FileHeart;
export const FileHeartSolid = mod.FileHeartSolid;
export const FileHorizontal = mod.FileHorizontal;
export const FileHorizontalSolid = mod.FileHorizontalSolid;
export const FileInfo = mod.FileInfo;
export const FileInfoSolid = mod.FileInfoSolid;
export const FileMinus = mod.FileMinus;
export const FileMinusSolid = mod.FileMinusSolid;
export const FilePlus = mod.FilePlus;
export const FilePlusSolid = mod.FilePlusSolid;
export const FileQuestion = mod.FileQuestion;
export const FileQuestionSolid = mod.FileQuestionSolid;
export const FileRedo = mod.FileRedo;
export const FileRedoSolid = mod.FileRedoSolid;
export const FileSearch = mod.FileSearch;
export const FileSearchSolid = mod.FileSearchSolid;
export const FileShredder = mod.FileShredder;
export const FileShredderSolid = mod.FileShredderSolid;
export const FileSlash = mod.FileSlash;
export const FileSlashSolid = mod.FileSlashSolid;
export const FileSolid = mod.FileSolid;
export const FileUser = mod.FileUser;
export const FileUserSolid = mod.FileUserSolid;
export const FileWired = mod.FileWired;
export const FileWiredSolid = mod.FileWiredSolid;
export const FileX = mod.FileX;
export const FileXSolid = mod.FileXSolid;
export const FileZipper = mod.FileZipper;
export const FileZipperSolid = mod.FileZipperSolid;
export const Files = mod.Files;
export const FilesSolid = mod.FilesSolid;
export const Filter = mod.Filter;
export const FilterSolid = mod.FilterSolid;
export const FloppyDisk = mod.FloppyDisk;
export const Folder = mod.Folder;
export const FolderArrowDown = mod.FolderArrowDown;
export const FolderArrowDownSolid = mod.FolderArrowDownSolid;
export const FolderArrowLeft = mod.FolderArrowLeft;
export const FolderArrowLeftSolid = mod.FolderArrowLeftSolid;
export const FolderArrowRight = mod.FolderArrowRight;
export const FolderArrowRightSolid = mod.FolderArrowRightSolid;
export const FolderArrowUp = mod.FolderArrowUp;
export const FolderArrowUpSolid = mod.FolderArrowUpSolid;
export const FolderBlock = mod.FolderBlock;
export const FolderBlockSolid = mod.FolderBlockSolid;
export const FolderCheck = mod.FolderCheck;
export const FolderCheckSolid = mod.FolderCheckSolid;
export const FolderExclamation = mod.FolderExclamation;
export const FolderExclamationSolid = mod.FolderExclamationSolid;
export const FolderHeart = mod.FolderHeart;
export const FolderHeartSolid = mod.FolderHeartSolid;
export const FolderImage = mod.FolderImage;
export const FolderImageSolid = mod.FolderImageSolid;
export const FolderLock = mod.FolderLock;
export const FolderLockSolid = mod.FolderLockSolid;
export const FolderMinus = mod.FolderMinus;
export const FolderMinusSolid = mod.FolderMinusSolid;
export const FolderPlus = mod.FolderPlus;
export const FolderPlusSolid = mod.FolderPlusSolid;
export const FolderQuestion = mod.FolderQuestion;
export const FolderQuestionSolid = mod.FolderQuestionSolid;
export const FolderSearch = mod.FolderSearch;
export const FolderSearchSolid = mod.FolderSearchSolid;
export const FolderShield = mod.FolderShield;
export const FolderShieldSolid = mod.FolderShieldSolid;
export const FolderSolid = mod.FolderSolid;
export const FolderUser = mod.FolderUser;
export const FolderUserSolid = mod.FolderUserSolid;
export const FolderX = mod.FolderX;
export const FolderXSolid = mod.FolderXSolid;
export const Forms = mod.Forms;
export const FormsSolid = mod.FormsSolid;
export const Gear = mod.Gear;
export const GearSolid = mod.GearSolid;
export const Grid = mod.Grid;
export const GridPlus = mod.GridPlus;
export const GridPlusSolid = mod.GridPlusSolid;
export const GridSolid = mod.GridSolid;
export const Hashtag = mod.Hashtag;
export const Heart = mod.Heart;
export const HeartSolid = mod.HeartSolid;
export const Home = mod.Home;
export const HomeSolid = mod.HomeSolid;
export const InformationCircle = mod.InformationCircle;
export const InformationCircleSolid = mod.InformationCircleSolid;
export const Italic = mod.Italic;
export const Join = mod.Join;
export const Key = mod.Key;
export const KeySolid = mod.KeySolid;
export const Keyboard = mod.Keyboard;
export const KeyboardSolid = mod.KeyboardSolid;
export const Layers = mod.Layers;
export const LayersSolid = mod.LayersSolid;
export const Link = mod.Link;
export const List = mod.List;
export const LocationPin = mod.LocationPin;
export const LocationPinSolid = mod.LocationPinSolid;
export const Lock = mod.Lock;
export const LockSlash = mod.LockSlash;
export const LockSlashSolid = mod.LockSlashSolid;
export const LockSolid = mod.LockSolid;
export const MagicWand = mod.MagicWand;
export const MagicWandSolid = mod.MagicWandSolid;
export const Mail = mod.Mail;
export const Map = mod.Map;
export const MapSolid = mod.MapSolid;
export const Menu = mod.Menu;
export const MessageCircleBlank = mod.MessageCircleBlank;
export const MessageCircleBlankSolid = mod.MessageCircleBlankSolid;
export const MessageCircleDots = mod.MessageCircleDots;
export const MessageCircleDotsSolid = mod.MessageCircleDotsSolid;
export const MessageSquareChat = mod.MessageSquareChat;
export const MessageSquareChatSolid = mod.MessageSquareChatSolid;
export const Meter = mod.Meter;
export const MeterSolid = mod.MeterSolid;
export const Minus = mod.Minus;
export const MinusCircle = mod.MinusCircle;
export const MinusCircleSolid = mod.MinusCircleSolid;
export const Move = mod.Move;
export const Notes = mod.Notes;
export const NotesSolid = mod.NotesSolid;
export const Numberlist = mod.Numberlist;
export const ObjectsAlignBottom = mod.ObjectsAlignBottom;
export const ObjectsAlignBottomSolid = mod.ObjectsAlignBottomSolid;
export const ObjectsAlignCenterHorizontal = mod.ObjectsAlignCenterHorizontal;
export const ObjectsAlignCenterHorizontalSolid = mod.ObjectsAlignCenterHorizontalSolid;
export const ObjectsAlignCenterVertical = mod.ObjectsAlignCenterVertical;
export const ObjectsAlignCenterVerticalSolid = mod.ObjectsAlignCenterVerticalSolid;
export const ObjectsAlignLeft = mod.ObjectsAlignLeft;
export const ObjectsAlignLeftSolid = mod.ObjectsAlignLeftSolid;
export const ObjectsAlignRight = mod.ObjectsAlignRight;
export const ObjectsAlignRightSolid = mod.ObjectsAlignRightSolid;
export const ObjectsAlignTop = mod.ObjectsAlignTop;
export const ObjectsAlignTopSolid = mod.ObjectsAlignTopSolid;
export const PaperAirplane = mod.PaperAirplane;
export const PaperAirplaneSolid = mod.PaperAirplaneSolid;
export const Paperclip = mod.Paperclip;
export const Pen = mod.Pen;
export const PenCircle = mod.PenCircle;
export const PenCircleSolid = mod.PenCircleSolid;
export const PenLineSolid = mod.PenLineSolid;
export const PenSlash = mod.PenSlash;
export const PenSlashSolid = mod.PenSlashSolid;
export const PenSolid = mod.PenSolid;
export const Phone = mod.Phone;
export const PhoneSolid = mod.PhoneSolid;
export const Pin = mod.Pin;
export const PinSolid = mod.PinSolid;
export const Play = mod.Play;
export const Plus = mod.Plus;
export const PlusCircle = mod.PlusCircle;
export const PlusCircleSolid = mod.PlusCircleSolid;
export const Printer = mod.Printer;
export const PrinterSolid = mod.PrinterSolid;
export const QuestionCircle = mod.QuestionCircle;
export const QuestionCircleSolid = mod.QuestionCircleSolid;
export const Reciept = mod.Reciept;
export const RecieptSolid = mod.RecieptSolid;
export const Redo = mod.Redo;
export const Refresh = mod.Refresh;
export const RefreshCcwClock = mod.RefreshCcwClock;
export const Refreshoff = mod.Refreshoff;
export const Rename = mod.Rename;
export const RenameSolid = mod.RenameSolid;
export const ResizeHandle = mod.ResizeHandle;
export const RocketLaunch = mod.RocketLaunch;
export const RocketLaunchSolid = mod.RocketLaunchSolid;
export const Scalable = mod.Scalable;
export const ScalableSolid = mod.ScalableSolid;
export const Scissors = mod.Scissors;
export const Search = mod.Search;
export const SearchMinus = mod.SearchMinus;
export const SearchMinusSolid = mod.SearchMinusSolid;
export const SearchPlus = mod.SearchPlus;
export const SearchPlusSolid = mod.SearchPlusSolid;
export const SearchSolid = mod.SearchSolid;
export const Select = mod.Select;
export const SelectorHorizontal = mod.SelectorHorizontal;
export const SelectorVertical = mod.SelectorVertical;
export const Shapes = mod.Shapes;
export const ShapesSolid = mod.ShapesSolid;
export const Share = mod.Share;
export const ShareSolid = mod.ShareSolid;
export const ShieldCheck = mod.ShieldCheck;
export const ShieldCheckSolid = mod.ShieldCheckSolid;
export const Signpost = mod.Signpost;
export const SignpostSolid = mod.SignpostSolid;
export const SlashBack = mod.SlashBack;
export const SlashForward = mod.SlashForward;
export const Smile = mod.Smile;
export const SmileSolid = mod.SmileSolid;
export const Snooze = mod.Snooze;
export const SquareBolt = mod.SquareBolt;
export const SquareBoltSolid = mod.SquareBoltSolid;
export const SquareChart = mod.SquareChart;
export const SquareChartSolid = mod.SquareChartSolid;
export const Star = mod.Star;
export const StarSolid = mod.StarSolid;
export const Status = mod.Status;
export const StatusSolid = mod.StatusSolid;
export const Strikethrough = mod.Strikethrough;
export const Suitcase = mod.Suitcase;
export const SuitcaseSolid = mod.SuitcaseSolid;
export const Table = mod.Table;
export const Tag = mod.Tag;
export const TagSolid = mod.TagSolid;
export const TeamMember = mod.TeamMember;
export const TeamMemberSolid = mod.TeamMemberSolid;
export const Text = mod.Text;
export const Timer = mod.Timer;
export const Translate = mod.Translate;
export const Trash = mod.Trash;
export const TrashSolid = mod.TrashSolid;
export const Truck = mod.Truck;
export const TruckSolid = mod.TruckSolid;
export const Underline = mod.Underline;
export const Undo = mod.Undo;
export const User = mod.User;
export const UserBlock = mod.UserBlock;
export const UserBlockSolid = mod.UserBlockSolid;
export const UserCheck = mod.UserCheck;
export const UserCheckSolid = mod.UserCheckSolid;
export const UserExclamation = mod.UserExclamation;
export const UserExclamationSolid = mod.UserExclamationSolid;
export const UserMinus = mod.UserMinus;
export const UserMinusSolid = mod.UserMinusSolid;
export const UserPen = mod.UserPen;
export const UserPenSolid = mod.UserPenSolid;
export const UserPlus = mod.UserPlus;
export const UserPlusSolid = mod.UserPlusSolid;
export const UserQuestion = mod.UserQuestion;
export const UserQuestionSolid = mod.UserQuestionSolid;
export const UserSearch = mod.UserSearch;
export const UserSearchSolid = mod.UserSearchSolid;
export const UserShield = mod.UserShield;
export const UserShieldSolid = mod.UserShieldSolid;
export const UserSolid = mod.UserSolid;
export const UserX = mod.UserX;
export const UserXSolid = mod.UserXSolid;
export const Users = mod.Users;
export const UsersSolid = mod.UsersSolid;
export const Wallet = mod.Wallet;
export const WalletSolid = mod.WalletSolid;
export const Wifi = mod.Wifi;
export const WifiSlash = mod.WifiSlash;
export const X = mod.X;
export const XCircle = mod.XCircle;
export const XCircleSolid = mod.XCircleSolid;
